import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  ListGroup,
  Badge,
  Button,
} from "react-bootstrap";
import parcelBoy from "../../assets/images/parcelBoy.png";
import NavbarSection from "./NavbarSection";
import Footer from "./Footer";

const AboutUs = () => (
  <div className="about-page">
    <NavbarSection />
    {/* Hero Section */}
    <section className="text-white">
      <Container fluid className="">
        <Row className="align-items-center g-0" style={{ minHeight: 200 }}>
          {/* Angled red banner with headline */}
          <Col
            lg={6}
            className="d-flex align-items-center ms-0 ms-lg-5"
            style={{
              //marginLeft:100,
              backgroundColor: "#e53935",
              height: 200,
              clipPath: "polygon(0 0, 95% 0, 75% 100%, 0 100%)",
            }}
          >
            <p
              className="lead mb-0 ms-4 me-3"
              style={{
                fontSize: 42,
                fontWeight: 700,
                letterSpacing: 0.5,
                lineHeight: 1.15,
              }}
            >
              PLATFORM FOR POSTAL <br /> DELIVERY CONTRACTORS
            </p>
          </Col>

          {/* Right image block */}
          <Col lg={5} className="text-center">
            <div
              className="bg-white d-flex justify-content-center align-items-center"
              style={{ height: 400 }}
            >
              <img
                src={parcelBoy}
                alt="Delivery professional holding a parcel"
                className="img-fluid"
                style={{
                  maxHeight: 400,
                  objectFit: "contain",
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>

    {/* About + Disclaimer */}
    <Container className="my-5">
      <Row className="g-4">
        <Col lg={12}>
          <Card className="border-0 shadow-sm rounded-4">
            <Card.Body className="p-4 p-lg-5">
              <h2 className="h3 mb-3">About Us</h2>
              <p className="mb-0">
                Daily Post Hub is a powerful platform designed to support
                Australia Post contractors in managing their daily operations
                effortlessly. From employee task tracking and parcel sorting to
                invoicing and mobile access, everything is brought together in a
                single platform. Built for both contractors and employees, Daily
                Post Hub saves time, reduces fuel costs with optimized delivery
                routes, and boosts overall productivity.
              </p>
              <div className="disclaimer mt-3 p-3 rounded-3">
                <strong>Disclaimer:</strong> Daily Post Hub is an independent
                service and is not affiliated with, endorsed, or operated by
                Australia Post.
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Features and Benefits */}
      <Row className="g-4 mt-1">
        <Col lg={6}>
          <Card className="feature-card border-0 shadow-sm h-100 rounded-4">
            <Card.Body className="p-4">
              <div className="d-flex align-items-center mb-3">
                <div className="icon-badge me-2">⚙️</div>
                <h3 className="h4 mb-0">Key Features</h3>
              </div>
              <ListGroup variant="flush" className="list-unstyled">
                <li className="list-item">✔ Multi-User Access</li>
                <li className="list-item">✔ Mobile-Friendly</li>
                <li className="list-item">✔ Automatic Parcel Sorting</li>
                <li className="list-item">✔ Employee Task Management</li>
                <li className="list-item">✔ Invoicing</li>
                <li className="list-item">✔ Holiday Management</li>
                <li className="list-item">✔ Flexible Plans</li>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6}>
          <Card className="benefit-card border-0 shadow-sm h-100 rounded-4">
            <Card.Body className="p-4">
              <div className="d-flex align-items-center mb-3">
                <div className="icon-badge me-2">🚀</div>
                <h3 className="h4 mb-0">Benefits for User</h3>
              </div>
              <ListGroup variant="flush" className="list-unstyled">
                <li className="list-item">✔ One-Click Control</li>
                <li className="list-item">✔ Mobile Access</li>
                <li className="list-item">✔ Cut Fuel Costs</li>
                <li className="list-item">✔ Save Time</li>
                <li className="list-item">
                  ✔ Employees can create and manage their own tasks every day.
                </li>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    <Footer/>
    {/* Styles */}
    <style jsx="true">{`
      .hero-section {
        background: linear-gradient(135deg, #0d6efd 0%, #6610f2 100%);
      }
      .image-frame {
        background: white;
        border-radius: 1rem;
        padding: 0.5rem;
      }
      .disclaimer {
        background: #f8f9fa;
        border-left: 4px solid #0d6efd;
      }
      .feature-card .list-item,
      .benefit-card .list-item {
        padding: 0.5rem 0;
        border-bottom: 1px dashed #edf0f3;
      }
      .feature-card .list-item:last-child,
      .benefit-card .list-item:last-child {
        border-bottom: none;
      }
      .icon-badge {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        background: #eef2ff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.1rem;
      }
    `}</style>
  </div>
);

export default AboutUs;
